import { render, staticRenderFns } from "./lottery-animate.vue?vue&type=template&id=6a94a59d&scoped=true&"
import script from "./lottery-animate.vue?vue&type=script&lang=js&"
export * from "./lottery-animate.vue?vue&type=script&lang=js&"
import style0 from "./lottery-animate.vue?vue&type=style&index=0&id=6a94a59d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a94a59d",
  null
  
)

export default component.exports